import { Grid, useMediaQuery } from "@mui/material";

import type { IPaginationResult } from "@dzambalaorg/types-collection";
import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import { StyledEmptyWrapper, StyledPagination } from "@framework/styled";
import type { IContract } from "@framework/types";
import { useFetchQuery } from "@dzambalaorg/react-hooks";

import { RaffleListItem } from "./item";

export const RaffleList = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IContract>
  >("/raffle/contracts", { enableInfiniteScroll: isMd });

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "raffle"]} />

      <PageHeader message="pages.raffle-list.title" />

      <SearchWithFilters />

      <ProgressOverlay isLoading={isLoading}>
        <Grid container spacing={2}>
          <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
            {allRows.map(raffle => (
              <Grid size={{ lg: 4, sm: 6, xs: 12 }} key={raffle.id}>
                <RaffleListItem contract={raffle} />
              </Grid>
            ))}
          </StyledEmptyWrapper>
        </Grid>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Grid>
  );
};
